import { render, staticRenderFns } from "./SiteLink.vue?vue&type=template&id=4437681a&"
import script from "./SiteLink.vue?vue&type=script&lang=js&"
export * from "./SiteLink.vue?vue&type=script&lang=js&"
import style0 from "./SiteLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports